import ImpactMain from "../components/impact/ImpactMain";
import SuccessStory from "../components/impact-success-story/SuccessStory";
import { Helmet } from "react-helmet";
import bm from "../components/100-board-members/BoardMembers100.module.scss";

export default function Impact() {
  return (
    <div className={bm["page-wrapper"]}>
      <Helmet>
        <title>Women Creating Impact with Iron Lady</title>
        <meta name="description" content="Meet the extraordinary women who achieved top leadership success and created lasting impact with Iron Lady. Explore their inspiring journeys and discover how our programs empower women to lead with confidence, strategy, and purpose." />
        <link rel="canonical" href="https://iamironlady.com/impact" />
      </Helmet>

      <ImpactMain />
      <SuccessStory />
    </div>
  );
}
